import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowSE.svg",
  "use": "ArrowSE.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ArrowSE.svg\"><path d=\"M46,48H25a2,2,0,1,1,0-4H41.218l-24.62-24.6194A1.9895,1.9895,0,0,1,19.4,16.5555l24.6,24.6V25a2,2,0,0,1,4,0V46A2,2,0,0,1,46,48Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol